export const EMPTY_STATE_INFO = {
  title: "Investment Levels",
  description:
    "The Investment Levels module lets you see how your ROI changes as you increase spending on a specific media channel.",
  guideText:
    "To get started, use the toolbar above to select a Comparison View and the Channels you want to review. ",
};

export const INSUFFICIENT_DATA_INFO = {
  title: "Insufficient Data",
  description:
    "We couldn’t generate this Saturation Curve due to insufficient data. This might be because spend levels are too low, or we can’t detect a statistically significant correlation between spend and revenue. ",
  guideText: "For more information, contact your Mutinex Marketing Scientist. ",
};
